import type { EngineEvent, EngineEventListener } from './events';

/**
 * Bus de eventos interno del motor.
 *
 * Permite que las capas de renderizado y un portal anfitrión se suscriban a
 * los eventos documentados sin acoplarse al estado interno.
 */
export class EventBus {
  private listeners = new Set<EngineEventListener>();

  on(listener: EngineEventListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  emit(event: EngineEvent): void {
    // Copia para permitir (de)suscripciones durante la emisión.
    for (const listener of [...this.listeners]) {
      try {
        listener(event);
      } catch (err) {
        // Un listener defectuoso no debe romper el motor.
        console.error('[adventurengine] listener error', err);
      }
    }
  }

  clear(): void {
    this.listeners.clear();
  }
}
